"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerMenuPageLink = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../../components/base-component");
const key_1 = require("../../utils/key");
const DRAWER_MENU_SELECTOR = 'drawer-menu';
class DrawerMenuPageLink extends base_component_1.BaseComponent {
    mountComponent() {
        this.addListener(this, 'click', this.handlePageLinkClick);
        this.addListener(this, 'keyup', this.handleKeyDown);
    }
    handlePageLinkClick = (event) => {
        event.preventDefault();
        this.setPage();
    };
    handleKeyDown = (event) => {
        if ((0, key_1.isEnterKey)(event)) {
            event.preventDefault();
            this.setPage();
        }
    };
    setPage() {
        const drawerMenu = (0, utils_1.$elParent)(DRAWER_MENU_SELECTOR, this);
        if (drawerMenu) {
            drawerMenu.setPage(drawerMenu.pageMap[this.dataset.pageId]);
        }
    }
}
exports.DrawerMenuPageLink = DrawerMenuPageLink;
